var filterToTwo = (value) => {
    if (value && value != 0 && value != null) {
        let valStr = value + '';
        if (Number(valStr) != 0) {
            return value.toFixed(2);
        }
    }
    return value;
}


export { filterToTwo }